export default __webpack_public_path__ + "static/media/portfoliohmi.8c1989c8.png";